const monitoringWork = {
  state: {
    // 视图设置
    viewData: {
      macInstanceId: false, // 餐柜ID
      machineNo: true, // 餐柜编号
      macType: false, // 餐柜类型
      macModeInMac: true, // 设备模式
      macStatus: true, // 设备状态
      connectStatus: true, // 网络状态
      workOrder: true, // 工单
      machDoor: true, // 门状态
      boilState: true, // 锅炉状态
      coldState: true, // 冷藏状态
      reposQtyDtoList: false, // 库存
      isFeed: true // 是否上料
    },
    viewDataLabel: {
      macInstanceId: '餐柜ID',
      machineNo: '餐柜编号',
      macType: '餐柜类型',
      macModeInMac: '设备模式',
      macStatus: '设备状态',
      connectStatus: '网络状态',
      workOrder: '工单',
      machDoor: '门状态',
      boilState: '锅炉状态',
      coldState: '冷藏状态',
      reposQtyDtoList: '库存',
      isFeed: '是否上料'
    },
    // 监控数据
    statusNumList: []
  },
  actions: {},
  mutations: {
    SET_VIEWDATA: (state, viewData) => {
      state.viewData = viewData
    },
    SET_STATUSNUMLIST: (state, statusNumList) => {
      state.statusNumList = statusNumList
    }
  }
};
export default monitoringWork